// Editorial QA corrections to unreviewed machine drafts. NOT professional sign-off.
// Per-locale, per-source-ID patches preserve the untouched machine output and audit trail.
import a from './neonatalParentQaCorrectionsA.js';
import b from './neonatalParentQaCorrectionsB.js';
import c from './neonatalParentQaCorrectionsC.js';
import d from './neonatalParentQaCorrectionsD.js';
import e from './neonatalParentQaCorrectionsE.js';

const patches = {};
for (const set of [a, b, c, d, e]) {
  for (const [locale, changes] of Object.entries(set)) {
    patches[locale] = { ...(patches[locale] || {}), ...changes };
  }
}
export const NEONATAL_PARENT_QA_CORRECTIONS = Object.freeze(Object.fromEntries(
  Object.entries(patches).map(([locale, changes]) => [locale, Object.freeze(changes)]),
));
export const NEONATAL_PARENT_QA_STATUS = 'draft_editorial_qa_not_professionally_reviewed';
export function neonatalQaCorrections(locale) {
  return NEONATAL_PARENT_QA_CORRECTIONS[String(locale || '').toLowerCase().split('-')[0]] || {};
}
